import { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardTitle,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import "../styles/bookings-list-cards.css";
import { useDispatch, useSelector } from "react-redux";
import { toggleBookingModal, getBookingDetails } from "../Features/authSlice";
import axios from "axios";
import { useOutletContext } from "react-router-dom";

const BookingList = () => {
  const dispatch = useDispatch();
  // const { cardData } = useOutletContext();
  const { currentUser } = useSelector((state) => state.user.currentUser);

  const { cardData } = useOutletContext();

  const [currentPage, setCurrentPage] = useState(1);
  const cardsPerPage = 6; // Number of cards to display per page

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  const currentCards = cardData.slice(indexOfFirstCard, indexOfLastCard);

  const totalPages = Math.ceil(cardData.length / cardsPerPage);

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <Col lg="7" md="7">
        <Row>
          <h4 className="fw-bold mb-4">Bookings History</h4>
        </Row>
        <Col style={{ height: "78%" }}>
          {currentCards.length === 0 ? (
            <>
              <Row
                className="d-flex justify-content-center align-items-center text-center"
                style={{ height: "75%" }}
              >
                <Row
                  style={{
                    fontFamily: "Arial, Helvetica, sans-serif",
                  }}
                >
                  <h1>Oops !!!</h1>
                  <h5>No Bookings Done Yet</h5>
                </Row>
              </Row>
            </>
          ) : (
            currentCards.map((card) => (
              <Row className="gap-1 mb-2">
                <Col>
                  <Card body>
                    <CardTitle
                      tag="h5"
                      className="d-flex justify-content-between"
                    >
                      {card.id}
                      <button
                        className="contact__btn btn-sm"
                        type="button"
                        onClick={() => {
                          dispatch(getBookingDetails(card));
                          dispatch(toggleBookingModal());
                        }}
                      >
                        Show Details
                      </button>
                    </CardTitle>
                  </Card>
                </Col>
              </Row>
            ))
          )}
        </Col>

        {/* <Row className="gap-1 mb-2">
          <Col>
            <Card body>
              <CardTitle tag="h5" className="d-flex justify-content-between">
                Here come's the booking id{" "}
                <button
                  className="contact__btn btn-sm"
                  type="button"
                  // onClick={handleSubmit}
                >
                  Show Details
                </button>
              </CardTitle>
            </Card>
          </Col>
        </Row> */}
        <Row>
          <Pagination>
            {Array.from({ length: totalPages }).map((_, index) => (
              <PaginationItem key={index} active={index + 1 === currentPage}>
                <PaginationLink
                  className="pagination-links"
                  onClick={() => handlePageClick(index + 1)}
                >
                  {index + 1}
                </PaginationLink>
              </PaginationItem>
            ))}
          </Pagination>
        </Row>
      </Col>
    </>
  );
};

export default BookingList;
